export default __webpack_public_path__ + "static/media/img_home.8b1f0f7b.png";